export const homeModule = {
  address: "地址",
  currentAddress: "位置信息",
  position: "地图",
  positioning: "正在定位",
  positionFail: "定位失败",
  addressList: "地址列表",
  reposition: "重新定位",
  recommendStore: "推荐店铺",
  sort1: "综合排序",
  sort2: "好评优先",
  sort3: "人均从低到高",
  sort4: "人均从高到低",
  sort5: "配送费最低",
  filterDistance: "距离",
  filterSales: "销量",
  filter: "筛选",
  filterPrice: "价格筛选",
  devCondition: "配送条件",
  storeType: "店铺类型",
  manage: "管理",
  positionError: "定位失败，请使用地址搜索或都道府县搜索",
  changeText: "变更",
  noAddressTitle: "根据地址搜索店铺",
  memberPrivilege: "会员特权",
  productCoupon: "储值卡",
  appointment: "预约",
  lineUp: "排队",
};
export const searchModule = {
  sort: "排序",
  addressPlace: "请输入店铺名",
  historySearch: "历史搜索",
  noData: "没有数据",
};
